<template>
  <div class="level-circle-wrapper" :style="circleSizeStyle()">
    <svg class="level-circle" :style="circleSizeStyle()">
      <path :d="calculationCircleParameters()" :fill="color" />
      <circle :cx="size / 2" :cy="size / 2" :r="size / 2 - 10" fill="#FAFAFA" />
    </svg>
    <div class="skill-name" v-html="name" />
    <div class="skill-percentage">{{ `${percentage}%` }}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: () => ''
    },
    size: {
      type: String,
      default: () => '200'
    },
    percentage: {
      type: Number,
      default: () => 0
    },
    color: {
      type: String,
      default: () => 'rgb(123, 255, 0)'
    }
  },
  methods: {
    goTo(to) {
      this.$router.push(to)
    },
    circleSizeStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    },
    calculationCircleParameters() {
      const halfSize = this.size / 2
      const centerXY = `${halfSize},${halfSize}`
      const percentage = this.percentage !== 100 ? this.percentage : 99.9999
      const radian = 2 * Math.PI * (percentage / 100)
      const largeArcFlag = radian <= Math.PI ? 0 : 1
      const endX = halfSize + Math.cos(radian - Math.PI / 2) * halfSize
      const endY = halfSize + Math.sin(radian - Math.PI / 2) * halfSize
      return `M${centerXY} L${halfSize},0 A ${centerXY} 0 ${largeArcFlag},1 ${endX},${endY} Z`
    }
  }
}
</script>

<style>
.level-circle-wrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.level-circle {
  position: absolute;
  top: 0;
  left: 0;
}

.skill-name {
  font-size: 16px;
  z-index: 1;
}

.skill-percentage {
  font-size: 16px;
  z-index: 1;
  color: rgb(117, 117, 117);
}
</style>
